'use client';

import { c as _c } from "react/compiler-runtime";
import SettingConfig from '@module/config/setting';
import { aspCond } from '@module/helpers/conditions/condition';
import { useASPInfo } from '@module/queries/asp/query';
import { mainQueryKeys } from '@module/queries/main/mainQueryKeys';
import useIsDarkModeStore from '@module/stores/useIsDarkModeStore';
import useIsMounted from '@module/utils/useIsMounted';
import { Skeleton } from '@pc/components/ui/skeleton';
import { useQueryClient } from '@tanstack/react-query';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
interface Props {
  openNewWindow?: boolean;
}
function TopNavLogo(t0) {
  const $ = _c(25);
  const {
    openNewWindow
  } = t0;
  const isMounted = useIsMounted();
  const queryClient = useQueryClient();
  const pathname = usePathname();
  const {
    isDark
  } = useIsDarkModeStore();
  const {
    data: aspInfo
  } = useASPInfo();
  const getHref = _temp;
  let t1;
  if ($[0] !== openNewWindow) {
    t1 = () => {
      if (aspCond.if("new-asp")) {
        return "_self";
      }
      return openNewWindow ? "_blank" : "_self";
    };
    $[0] = openNewWindow;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getTarget = t1;
  const [linkState, setLinkState] = useState(_temp2);
  let t2;
  if ($[2] !== getTarget || $[3] !== isMounted || $[4] !== pathname) {
    t2 = () => {
      if (!isMounted) {
        return;
      }
      setLinkState({
        href: getHref(pathname),
        target: getTarget()
      });
    };
    $[2] = getTarget;
    $[3] = isMounted;
    $[4] = pathname;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isMounted || $[7] !== openNewWindow || $[8] !== pathname) {
    t3 = [isMounted, pathname, openNewWindow];
    $[6] = isMounted;
    $[7] = openNewWindow;
    $[8] = pathname;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  if ($[10] !== pathname || $[11] !== queryClient) {
    t4 = () => {
      if (pathname.includes("/play/")) {
        return;
      }
      queryClient.invalidateQueries({
        queryKey: mainQueryKeys.fetchWebMainPage._def,
        exact: false
      });
      if (pathname === "/" && typeof window !== "undefined" && typeof window.callDM === "function") {
        window.callDM();
      }
    };
    $[10] = pathname;
    $[11] = queryClient;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleClick = t4;
  if (!isMounted) {
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Skeleton className="h-8 w-[108px]" />;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    return t5;
  }
  const t5 = openNewWindow ? "noopener noreferrer" : undefined;
  let t6;
  if ($[14] !== aspInfo?.imgLogoBlack || $[15] !== aspInfo?.imgLogoW || $[16] !== aspInfo?.title || $[17] !== isDark) {
    t6 = aspInfo?.title ? <img className="w-[115px]" src={isDark ? aspInfo?.imgLogoBlack : aspInfo?.imgLogoW} alt="logo" /> : <div className="h-[20px] w-[115px] bg-50% bg-cover bg-logo-live bg-no-repeat" />;
    $[14] = aspInfo?.imgLogoBlack;
    $[15] = aspInfo?.imgLogoW;
    $[16] = aspInfo?.title;
    $[17] = isDark;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== handleClick || $[20] !== linkState.href || $[21] !== linkState.target || $[22] !== t5 || $[23] !== t6) {
    t7 = <div className="flex h-full w-full items-center justify-center"><Link prefetch={false} className="min-w-[108px]" href={linkState.href} target={linkState.target} rel={t5} onClick={handleClick}>{t6}</Link></div>;
    $[19] = handleClick;
    $[20] = linkState.href;
    $[21] = linkState.target;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}
function _temp2() {
  return {
    href: "/",
    target: "_self" as '_self' | '_blank'
  };
}
function _temp(currentPathname) {
  if (aspCond.if("new-asp") && SettingConfig.aspUtils?.aspInfo?.urlPc) {
    const routesThatGoesToASPWebsite = ["/live", "/pick", "/ranking", "/search"];
    if (routesThatGoesToASPWebsite.some(route => currentPathname.startsWith(route))) {
      return SettingConfig.aspUtils?.aspInfo?.urlPc;
    }
    return "/live";
  }
  return "/";
}
export default TopNavLogo;